import { HOME_TO_VISIT_POSTCODE_DISTANCE_ERROR_DISMISS } from '../../constants/types';

function dismissError() {
  return {
    type: HOME_TO_VISIT_POSTCODE_DISTANCE_ERROR_DISMISS,
  };
}

export { dismissError };
